// 🎞️ F1 (Nina 09-26, PORTED_HOME_HANDOFF §3 ruling 29): in a ported room the
// pinned pick is the RESIDENT's pick, never the host's. "It could say 'I
// wanted to watch this video with you'". A display relabel only: the stored
// pick keeps its fields (older picks say source 'host'), zero data writes,
// zero model calls. Everyone in the room sees the same words.
//
// Not ported => the SAME object back (every other room renders as today,
// and a React.memo comparator keyed on the pick keeps its identity).
// Names only, never a guessed pronoun; no name => "A pick for you".
export const RESIDENT_VIDEO_CAPTION = 'I wanted to watch this video with you.';
export const RESIDENT_SHOW_CAPTION = 'I wanted to show you this.';

export function residentPick(pick, { ported = false, name = null, image = null } = {}) {
  // R4 (09-26): only a pick the SERVER minted as his (source 'resident', the
  // ported media pass) is relabelled. A host-minted pick left over from an
  // older backend, or a human's own pin (source 'human'), keeps its words and
  // its identity: relabelling those attributed someone else's pick to him.
  if (!pick || !ported || pick.source !== 'resident') return pick;
  const who = String(name || '').trim() || null;
  return {
    ...pick,
    pick_label: who ? `${who}'s pick` : 'A pick for you',
    host_name: who,
    host_emoji: null,
    by_image: image || null,
    caption: pick.type === 'youtube' ? RESIDENT_VIDEO_CAPTION : RESIDENT_SHOW_CAPTION,
    _resident: true,
  };
}
